<template>
  <div>
    <el-input readonly type="textarea" rows="22" :value="text" />
  </div>
</template>

<script>
import { apiSystemRunninglog } from '@/api/common'
export default {
  data() {
    return {
      text: ''
    }
  },
  created() {
    this.queryData()
  },
  methods: {
    async queryData() {
      const res = await apiSystemRunninglog()
      this.text = res.data
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/client-manage/components/RunningLog.vue